import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'site-configs' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
